export const SEND_EMAIL_REQUEST = '@help/SEND_EMAIL_REQUEST';
export const SEND_EMAIL_FALURE = '@help/SEND_EMAIL_FALURE';
export const SEND_EMAIL_SUCCESS = '@help/SEND_EMAIL_SUCCESS';
export const CLEAR_SUCCESS = '@help/CLEAR_SUCCESS';
export const CLEAR_ERROR = '@help/CLEAR_ERROR';
